
export default (https) => ({
  async getPermissionList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/get-permissions?${queryString}`);
    return response.data;
  },
  async getList(params = []) {
    const queryString = params
      .filter(param => param.value !== null && param.value !== undefined && param.value !== '')
      .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
      .join('&');

    const response = await https.get(`/roles?${queryString}`);
    return response.data;
  },

  async getById(id) {
    const response = await https.get(`/roles/${id}`);
    return response.data.data;
  },

  async add(payload) {
    const response = await https.post(`/roles`, payload);
    return response.data;
  },

  async update(id, payload) {
    const response = await https.put(`/roles/${id}`, payload);
    return response.data;
  },

  async deleteById(id) {
    const response = await https.delete(`/roles/${id}`);
    return response.data;
  },
});
